import { Component, Input, OnInit } from '@angular/core';
import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DataSharingService } from 'src/app/service/data-sharing.service';
import { Subscription } from "rxjs";
import { inputs } from '@syncfusion/ej2-angular-buttons/src/button/button.component';

@Component({
  selector: 'app-add-ecowas-config',
  templateUrl: './add-ecowas-config.component.html',
  styleUrls: ['./add-ecowas-config.component.scss']
})
export class AddEcowasConfigComponent implements OnInit {

  addEcowasConfigForm:FormGroup;
  submitted:boolean;
  orgidval:any;
  orgId:string;
  tableDataSubscription: Subscription;
  tableData:any;
  @Input() orgidData: any;

  constructor(private formBuilder: FormBuilder,
    private endpointsService: EndpointsService,
     private backendApiService: BackendApiService,
     private spinnerService:Ng4LoadingSpinnerService,
     private dataSharingService: DataSharingService) { }

  ngOnInit(): void {
    console.log("LLLLLL",this.orgidData)
    this.addEcowasConfig()
   console.log(">>>>>>>>>",sessionStorage.getItem('orgIdv'))
  
  }
  addEcowasConfig(){
    console.log("?????????",sessionStorage.getItem('orgIdv'))
    this.addEcowasConfigForm = this.formBuilder.group({   	
    orgId	:[],
    country_name:[],	
    welcome_sms	:[],
    goodbye_sms	:[],
    is_active	:['Y'],
    created_date:[],	
    updated_date:[],	
    operator_name:[],	
    time_zone:[],	
    short_code:[],	
    reminder_sms:[],	
    mcc	:[],
    mnc	:[],
    cc:[]	

    })
  }
 
  onAdd(){
    // this.submitted=true;
    // if(this.addEcowasConfigForm.invalid){
    //   return;
    // }
    console.log("aaa")
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_CONFIG +
      '&orgId=' + this.addEcowasConfigForm.get('orgId').value+
      '&country_name=' + this.addEcowasConfigForm.get('country_name').value+
      '&welcome_sms=' + this.addEcowasConfigForm.get('welcome_sms').value+
      '&goodbye_sms=' + this.addEcowasConfigForm.get('goodbye_sms').value+
      '&is_active=' + this.addEcowasConfigForm.get('is_active').value+
      '&created_date=' + this.addEcowasConfigForm.get('created_date').value+
      '&updated_date=' + this.addEcowasConfigForm.get('updated_date').value+
      '&operator_name=' + this.addEcowasConfigForm.get('operator_name').value+
      '&time_zone=' + this.addEcowasConfigForm.get('time_zone').value+
      '&short_code=' + this.addEcowasConfigForm.get('short_code').value+
      '&reminder_sms=' + this.addEcowasConfigForm.get('reminder_sms').value+
      '&mcc=' + this.addEcowasConfigForm.get('mcc').value+
      '&mnc=' + this.addEcowasConfigForm.get('mnc').value+
      '&cc=' + this.addEcowasConfigForm.get('cc').value
     

      )
      .subscribe(response => {
        console.log("responseeee",response)
        // if (response === null  || response === '{"status" : "false"}') {
        //   alert('Not Added');
          

        //   return;
        // }
        // else if( response === '{"status" : "Record with orgId already exists"}'){
        //   alert("Record with orgid already exit")
        // }
        //  else {
        //   alert('Added successfully');        
        //   this.spinnerService.show();
         
        // }
  })
  }
}


